function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.628906,
  y: 0.589844,
  width: 53.1562,
  height: 53.1562,
  rx: 11,
  fill: "#1BD741"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.22266 46.1523L10.8818 36.7183C9.17181 33.8164 8.2715 30.5148 8.2715 27.1231C8.2715 16.6798 16.7769 8.18359 27.2315 8.18359C37.6861 8.18359 46.1914 16.6798 46.1914 27.1231C46.1914 37.5663 37.6861 46.0625 27.2315 46.0625C23.9739 46.0625 20.7841 45.2296 17.9623 43.6479L8.22266 46.1523ZM18.4602 40.2023L19.0406 40.5563C21.5009 42.0567 24.3333 42.8497 27.2315 42.8497C35.9126 42.8497 42.9752 35.7948 42.9752 27.1231C42.9752 18.4513 35.9126 11.3964 27.2315 11.3964C18.5504 11.3964 11.4877 18.4513 11.4877 27.1231C11.4877 30.1446 12.3474 33.0788 13.9737 35.6084L14.3645 36.2163L12.8332 41.6492L18.4602 40.2023Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1249 17.7453L20.8513 17.678C20.4512 17.6569 20.0588 17.7864 19.7564 18.0411C19.139 18.5608 18.1517 19.5657 17.8484 20.8752C17.3962 22.8276 18.095 25.2185 19.9038 27.6093C21.7126 30.0001 25.0833 33.8255 31.0438 35.4592C32.9646 35.9857 34.4755 35.6308 35.6412 34.9079C36.5646 34.3354 37.201 33.4165 37.4304 32.3777L37.6338 31.457C37.6984 31.1643 37.5451 30.8674 37.2647 30.7421L32.9601 28.8188C32.6807 28.694 32.3493 28.7729 32.1614 29.009L30.4715 31.1325C30.3438 31.293 30.1253 31.3566 29.928 31.2894C28.7708 30.8951 24.8943 29.3214 22.7672 25.3497C22.675 25.1775 22.6979 24.9684 22.8287 24.8215L24.4438 23.0104C24.6088 22.8255 24.6505 22.5655 24.5513 22.3407L22.6958 18.1328C22.597 17.9087 22.3757 17.7586 22.1249 17.7453Z",
  fill: "white"
});

function SvgWhatsappSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSquare);
export default __webpack_public_path__ + "static/media/whatsapp-square.8c258f2b.svg";
export { ForwardRef as ReactComponent };